import React from 'react'
import Image from 'components/Image'
import FormContact from 'components/forms/FormContact'
import Inview from 'components/Inview'

const Component = ({ phoneLabel = `咨询电话`, buttonAddClass = '' }) => {
  return (
    <section
      id='contact'
      className='BlockContact BlockContact__Section-sc-4dhfy-0 fXGjDL'
    >
      <div className='container'>
        <div className='grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 md:items-end form--primary'>
          <div className='col-span-4 md:col-span-3 lg:col-span-5 bg--primary pr-6 pr0-md mt-24 mt0--md pt-12 pb-6 md:pt-16 md:pb-16 lg:pt-20 lg:pb-20 bg--primary--left relative'>
            <Inview>
              <h3
                className='h3 color--white mb-12 md:mb-20 fade-in-up'
                // style='transform: translate(0px, 20%); opacity: 0;'
              >
                极速开店 <br />
                拎包入驻
                <span className='color--white-transparent block'>
                  快联系我们
                </span>
              </h3>
            </Inview>
            <div className='lg:flex'>
              <div className='mr-20 mb-6 lg:mb-0'>
                <Inview>
                  <p className='color--grey-1 md mb-0 fade-in-up'>
                    {phoneLabel}
                  </p>
                  <p className='small color--grey-1 fade-in-up'>
                    <a
                      href='tel:4008502727'
                      target='_blank'
                      className='btn--text btn--text--large'
                    >
                      400-850-2727
                    </a>
                  </p>
                </Inview>
              </div>
            </div>
          </div>
          <div className='col-span-4 md:col-span-5 lg:col-span-7 lg:col-start-6 pt-6 relative bg--grey-2 bg--right md:mt-24 pt-20 md:pt-24 lg:pt-24 pb-20 md:pb-10 lg:pb-20'>
            <div className='grid grid-cols-4 md:grid-cols-7 relative z-10'>
              <div className='col-span-4 md:col-span-6 md:col-start-2 lg:col-span-5 lg:col-start-2'>
                <FormContact buttonAddClass={buttonAddClass} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg--contact'>
        <Inview triggerOnce={true}>
          <div className='image-bg zoom'>
            <Image filename='bg-cabbage.jpg' />
          </div>
        </Inview>
      </div>
    </section>
  )
}

export default Component
